<template>
  <v-container fluid fill-height justify-center id="scrolling-techniques-7" class="overflow-y-auto" key="remind">
    <transition name="router-anim" mode="out-in">
      <v-row v-if="success" key="1" class="max-w">
        <v-col>
          <div class="display-1 font-weight-medium mb-4 w-80">
            {{ $t('odbierz-email') }}
          </div>
          <div class="font-weight-light mb-5 c-lighter-1">
            {{ $t('przypomnienie-opis') }}
          </div>
          <v-btn x-large class="btn-secondary" to="/login">{{ $t('przejdz-login') }}</v-btn>
        </v-col>
      </v-row>
      <v-row px-4 v-else key="2" class="max-w">
        <v-col>
          <v-form
            ref="form"
            v-model="valid"
            class="px-5"
          >
            <div class="display-1 font-weight-medium mb-3">
              {{ $t('przyp-haslo') }}
            </div>
            <div class="font-weight-light mb-6 c-lighter-1">
              {{ $t('przyp-opis') }}
            </div>

            <v-text-field
            v-model="email"
            :rules="emailRules"
            label="E-mail"
            required
            ></v-text-field>
            
            <div class="text-center mt-8">
              <v-btn 
                :loading="saving"
                :disabled="saving" 
                @click="postForm"
                x-large class="w-100" color="primary"
              >
                {{ $t('przyp-haslo') }}
              </v-btn>
            </div>
            <div class="text-center mt-2">
              <v-btn x-large text class="w-100" to="/login">{{ $t('anuluj') }}</v-btn>
            </div>
          </v-form>
        </v-col>
      </v-row>
    </transition>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      valid: true,
      email: '',
      emailRules: [
        v => !!v || 'Wypełnij E-mail',
        v => /.+@.+/.test(v) || 'E-mail jest nieprawidłowy'
      ],
      saving: false,
      snackbar: false,
      snackbarText: '',
      snackbarColor: "error",
      success: false
    }),

    methods: {
      postForm () {
        this.saving = true;

        const formData = new URLSearchParams();
        formData.append('email', this.email);

        this.$store.dispatch('remind', formData)
        .then(res => {
          this.saving = false;
          if (res.error) {
            this.$store.commit("alert", {
              color: "error",
              text: res.error.code
            });
          } else {
            this.success = true;
          }
        });
      }
    }
  }
</script>

<style>

</style>
